<template>
  <div class="row">
    <div class="col-12">
      <table class="table table-sm table-striped">
        <thead>
          <tr>
            <th scope="col" class="align-middle text-center">ESTADO</th>
            <th scope="col" class="align-middle text-center">RESPONSABLE</th>
            <th scope="col" class="align-middle text-center">ROL</th>
            <th scope="col" class="align-middle text-center">FECHA INICIO</th>
            <th scope="col" class="align-middle text-center">FECHA FIN</th>
            <th scope="col" class="align-middle text-center">DÍAS</th>
            <th scope="col" class="align-middle text-center">TAREA</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(v, i) in log" :key="i">
            <td class="align-middle">{{ v.status.name }}</td>
            <td class="align-middle text-center" v-if=" v.status.code == 808">
              Sistema de Acreditación Ecuatoriano - SAE
            </td>
            <td class="align-middle text-center" v-if=" v.status.code != 808">
              {{
                v.user
                  ? `${v.user.first_name} ${v.user.last_name}`
                  : "PENDIENTE"
              }}
            </td>
            <td class="align-middle text-center">
              {{v.status.role ? `${v.status.role.name}`:'Sin asignar'}}
            </td>
            <td class="align-middle text-center">
              {{ v.created_at | dateFormat }}
            </td>
            <td class="align-middle text-center">
              <span v-if="v.task_finished">
                {{ v.updated_at | dateFormat }}
              </span>
            </td>
            <!-- <td class="align-middle text-center" :inner-html.prop="v.created_at | daysMade(v.updated_at, v.status.task_time)" >

            </td> -->
            <td class="align-middle text-center">
              <span class="badge badge-sm badge-pill badge-success" v-if="v.days > 0 && v.status.task_time > 0 && v.days>= v.status.task_time">
                {{ v.days }}
              </span>
              <span class="badge badge-sm badge-pill badge-success" v-if="v.days > 0 && v.status.task_time == null">
                {{ v.days }}
              </span>
              <span class="badge badge-sm badge-pill badge-warning" v-else-if="v.days > 0 && v.status.task_time > 0 && v.days < v.status.task_time">
                {{ v.days }}
              </span>
              <span class="badge badge-sm badge-pill badge-danger" v-else-if="v.days === 0">
                {{ v.days }}
              </span>
            </td>
            <td class="align-middle text-center">
              <span
                class="badge badge-sm badge-pill badge-warning"
                v-if="!v.task_finished"
                >EN PROGRESO</span
              >
              <span
                class="badge badge-sm badge-pill badge-success"
                v-if="v.task_finished"
                >FINALIZADO</span
              >
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { axiosGet } from "@/app/helpers/AxiosHelper";
export default {
  data() {
    return {
      log: [],
    };
  },
  created() {
    this.$hub.$on("reload-table", () => {
      this.getData();
    });
    this.getData();
  },
  filters: {
    dateFormat: function (value) {
      return value ? moment(value).format("YYYY-MM-DD HH:mm") : "";
    },
        daysMade: function (dateStart, dateEnd, taskTime){
      const _dateStart = new Date(dateStart);
      const _dateEnd = new Date(dateEnd);
      const _dateDiff = _dateEnd.getTime() - _dateStart.getTime();
      const daysDiff = Math.floor(_dateDiff/(1000*60*60*24))
      if (taskTime === daysDiff){
        return `<span class="badge badge-sm badge-pill badge-warning">${daysDiff}</span`;
      }else if(taskTime > daysDiff){
        return `<span class="badge badge-sm badge-pill badge-success">${daysDiff}</span`;
      }else{
        return `<span class="badge badge-sm badge-pill badge-danger">${daysDiff}</span`;
      }
    }
  },
  methods: {
    getData() {
      this.preloader = true;
      let url = `/historical/accreditation/${this.$store.state.common.accAppId}/log`;
      axiosGet(url)
        .then((response) => {
          if (response.status == 200) {
            this.log = response.data.log;
            this.$store.state.common.accApp = response.data.accApp;
          }
        })
        .catch(({ error }) => {
          console.log(error);
        })
        .finally(() => {
          this.preloader = false;
        });
    },
  },
};
</script>